import Enum from "../../../enums/Enum";

const EnumItemCategory = new Enum({
    CPT: {name: "Cpt"},
    RETAIL: {name: "Retail"},
    FEE: {name: "Fee"},
    CREDIT: {name: "Credit"}
});

export default EnumItemCategory;